import { GetMessagesFailure } from '@store/broadcast-messages/features/get-message/get-messages-failure';
import { GetMessagesSuccess } from '@store/broadcast-messages/features/get-message/get-messages-success';
import { IBroadcastMessagesState } from '@store/broadcast-messages/types';
import { AxiosResponse } from 'axios';
import { IBroadcastMessageDto } from 'lingopractices-models';
import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { createDeferredAction } from '../../../common/actions';
import { httpRequestFactory } from '../../../common/http-request-factory';
import { HttpRequestMethod } from '../../../common/http-request-method';
import { MAIN_API } from '../../../common/path';

export class GetMessages {
  static get action() {
    return createDeferredAction('broadcastMessages/GET_MESSAGES');
  }

  static get reducer() {
    return (draft: IBroadcastMessagesState) => {
      draft.requests.getBroadcastMessagesPending = true;

      return draft;
    };
  }

  static get saga() {
    return function* ({ meta }: ReturnType<typeof GetMessages.action>): SagaIterator {
      try {
        const { data } = GetMessages.httpRequest.call(
          yield call(() => GetMessages.httpRequest.generator()),
        );

        yield put(GetMessagesSuccess.action(data));
        meta?.deferred.resolve(data);
      } catch (e) {
        yield put(GetMessagesFailure.action());
        meta?.deferred.reject(e);
      }
    };
  }

  static get httpRequest() {
    return httpRequestFactory<AxiosResponse<IBroadcastMessageDto[]>, undefined>(
      MAIN_API.BROADCAST_MESSAGES,
      HttpRequestMethod.Get,
    );
  }
}
